function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { TYPES } from '../../../../constants';
import { handleOnKeyPress } from '../../../../helper/handlers';

// eslint-disable-next-line react/display-name
const InputTag = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    readOnly,
    inputControlClasses,
    id,
    type,
    disabled,
    maxLength,
    onKeyPress = () => {},
    required,
    isError,
    isSuccess,
    placeholder = '',
    name,
    prefix,
    suffix,
    label,
    helpText,
    validationText,
    dataTestId,
    ...restProps
  } = props;
  const ariaLabelledbyIds = () => {
    const ids = [label && `${id}-label`, prefix && `${id}-prefix`, suffix && `${id}-suffix`].filter(Boolean);
    return ids.join(' ') || null;
  };
  const ariaDescribedByIds = () => {
    const ids = [helpText && `${id}-helpText`, maxLength && `${id}-charCount`, validationText && (isError || isSuccess) && `${id}-validationText`].filter(Boolean);
    return ids.join(' ') || null;
  };
  return /*#__PURE__*/React.createElement("input", _extends({}, restProps, {
    "data-testid": dataTestId ? dataTestId : null,
    name: name,
    placeholder: placeholder ? placeholder : null,
    required: required,
    "aria-required": required ? required : null,
    "aria-describedby": ariaDescribedByIds(),
    "aria-invalid": isError ? isError : null,
    ref: ref,
    readOnly: readOnly,
    "aria-readonly": readOnly ? readOnly : null,
    className: inputControlClasses,
    id: id,
    type: type === TYPES.DATE ? TYPES.TEXT : type,
    disabled: disabled,
    "aria-disabled": disabled ? disabled : null,
    maxLength: maxLength,
    "aria-labelledby": ariaLabelledbyIds(),
    onKeyPress: event => handleOnKeyPress(event, onKeyPress, maxLength, event.target.value)
  }));
});
export default /*#__PURE__*/memo(InputTag);
InputTag.propTypes = {
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  inputControlClasses: PropTypes.string,
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES)),
  maxLength: PropTypes.number,
  onKeyPress: PropTypes.func,
  required: PropTypes.bool,
  isError: PropTypes.bool,
  isSuccess: PropTypes.bool,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  label: PropTypes.string,
  helpText: PropTypes.string,
  validationText: PropTypes.string,
  dataTestId: PropTypes.string
};